import React from "react";
import {
  Box,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Link,
} from "@material-ui/core";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  useStyles,
  PaymentMethodLogic,
  PaymentMethodService,
} from "./paymentMethod.module";
import AlertMessage from "../alert/alert";


const PaymentMethod = (props) => {
  const classes = useStyles();
  const {
    errors,
    isReady,
    translator,
    payment_method,
    handleChangeInPaymentMethod,
    handleChangeInTermsAndConditions,
  } = PaymentMethodLogic(props, PaymentMethodService);

  const [method, setMethod] = React.useState("credit_card");
  const [termsAccepted, setTermsAccepted] = React.useState(false);

  const handleMethodChange = (event) => {
    const value = event.target.value;
    setMethod(value);
    handleChangeInPaymentMethod(event);
  };

  const handleTermsChange = (event) => {
    setTermsAccepted(event.target.checked);
    handleChangeInTermsAndConditions(event);
  };

  React.useEffect(() => {
    handleChangeInPaymentMethod({ target: { value: "credit_card" } });
  }, []);
  

  return (
    <Box className={classes.paymentContainer}>
      <Typography className={classes.pageTitle}>Payment Method</Typography>

      <Typography className={classes.pageSubtitle}>
        Secure your carbon assets using our encrypted financial gateway. Choose
        your preferred method of settlement.
      </Typography>

      <RadioGroup
        value={method}
        onChange={handleMethodChange}
        className={classes.radioGroup}
      >
        <FormControlLabel
          value="credit_card"
          className={classes.formControlLabel}
          control={<Radio style={{ display: "none" }} />}
          label={
            <Box
              className={`${classes.paymentCard} ${
                method === "credit_card" ? classes.paymentCardActive : ""
              }`}
            >
              <Box className={classes.cardContent}>
                <Box className={classes.iconWrapper}>
                  <CreditCardIcon />
                </Box>
                <Box>
                  <Typography className={classes.cardTitle}>
                    Card payment
                  </Typography>
                  <Box className={classes.cardBadges}>
                    <span>VISA</span>
                    <span>MASTERCARD</span>
                    <span>AMEX</span>
                  </Box>
                </Box>
              </Box>
              <Box
                className={`${classes.radioCircle} ${
                  method === "credit_card" ? classes.radioCircleActive : ""
                }`}
              >
                <Box
                  className={`${classes.radioDot} ${
                    method === "credit_card" ? classes.radioDotActive : ""
                  }`}
                />
              </Box>
            </Box>
          }
        />

        {props.available >= props.total ? (
          <FormControlLabel
            value="wallet"
            className={classes.formControlLabel}
            control={<Radio style={{ display: "none" }} />}
            label={
              <Box
                className={`${classes.paymentCard} ${
                  method === "wallet" ? classes.paymentCardActive : ""
                }`}
              >
                <Box className={classes.cardContent}>
                  <Box className={classes.iconWrapper}>
                    <AccountBalanceWalletIcon />
                  </Box>
                  <Box>
                    <Typography className={classes.cardTitle}>
                      Wallet
                    </Typography>
                    <Typography className={classes.walletBalance}>
                      Available balance: {props.available} USD
                    </Typography>
                  </Box>
                </Box>
                <Box
                  className={`${classes.radioCircle} ${
                    method === "wallet" ? classes.radioCircleActive : ""
                  }`}
                >
                  <Box
                    className={`${classes.radioDot} ${
                      method === "wallet" ? classes.radioDotActive : ""
                    }`}
                  />
                </Box>
              </Box>
            }
          />
        ) : (
          <Box className={classes.paymentCardDisabled}>
            <Box className={classes.cardContent}>
              <Box className={classes.iconWrapperDisabled}>
                <AccountBalanceWalletIcon />
              </Box>
              <Box>
                <Typography className={classes.cardTitleDisabled}>
                  Wallet
                </Typography>
                <Typography className={classes.insufficientBalance}>
                  Insufficient balance
                </Typography>
              </Box>
            </Box>
            <Box className={classes.radioCircleDisabled} />
          </Box>
        )}
      </RadioGroup>

      <Box className={classes.termsContainer}>
        <Checkbox
          checked={termsAccepted}
          onChange={handleTermsChange}
          className={classes.checkbox}
        />
        <Typography className={classes.termsText}>
          I acknowledge that these carbon credits are subject to the{" "}
          <Link href="#" className={classes.termsLink}>
            Carbon Registry Protocols
          </Link>{" "}
          and agree to the terms and conditions of egreen.com regarding
          environmental asset transfers.
        </Typography>
      </Box>

      <Box className={classes.actionsContainer}>
        <Button
          className={classes.btnBack}
          startIcon={<ArrowBackIcon style={{ fontSize: 18 }} />}
          onClick={props.handleBack}
        >
          GO BACK
        </Button>
        <Button
          className={classes.btnPayment}
          onClick={payment_method}
          disabled={!isReady}
        >
          PAYMENT
        </Button>
      </Box>

      {errors && errors.api_error && (
        <Box style={{ marginTop: 24 }}>
          <AlertMessage type="error" text={errors.api_error} />
        </Box>
      )}
    </Box>
  );
};

export default PaymentMethod;
